import React from "react";
import "../../../../css/Common/Components/Cards/CardServices.css";
import "../../../../css/App.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

/**
 * CardServices component displays a service card with an image, title, content, and navigates to a link on click.
 *
 * @component
 * @param {Object} props - The props object.
 * @param {string} props.imgSrc - The source URL for the main image.
 * @param {string} props.imgSrcSmall - The source URL for a smaller version of the image (currently unused).
 * @param {string} props.title - The title displayed on the card.
 * @param {string|React.ReactNode} props.content - The content or description displayed on the card.
 * @param {string} props.link - The URL or route to navigate to when the card is clicked.
 * @param {string} [props.altText=""] - The alt text for the image.
 *
 * @returns {JSX.Element} The rendered CardServices component.
 */
const CardServices = ({ imgSrc, imgSrcSmall, title, content, link, altText="" }) => {
  const [clicked, setClicked] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div
        className={`Card-Services ${clicked ? "clicked" : ""}`}
        onClick={() => {
          setClicked(!clicked); // Toggle the clicked state
          navigate(link); // Navigate to the provided link
        }}
      >
        <img loading="eager" fetchPriority="high" src={imgSrc} alt={altText} />
        <div className="Card-Services-Content">
          <h2>{title}</h2>
        </div>
        <div className="Content-Large">{content} </div>
      </div>
    </>
  );
};

export default CardServices;
